import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, PropsWithChildren, useEffect, useMemo, useState } from 'react';
import { SynchronizationStatusContext, SynchronizationStatusContextValue } from 'record-it-components/context/SynchronizationStatusContext';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { AppEntityManager } from '../classes/entities/AppEntityManager';
import { AppEntityManagerApiAdapter } from '../classes/entities/AppEntityManagerApiAdapter';
import { StorageClearer } from '../classes/StorageClearer/StorageClearer';
import { EntityManagerContext, EntityManagerContextValue } from '../context/EntityManagerContext';
import { useAuth } from '../hooks/useAuth';
import { useInitializable } from '../hooks/useInitializable/useInitializable';
import { testingHelper } from '../testingHelper';
export const AppEntityManagerContextProvider: FunctionComponent<PropsWithChildren> = React.memo(props => {
  const $ = _c(21);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    children
  } = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      inProgress: false,
      itemsToSynchronizeInfos: []
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [synchronizationStatus, setSynchronizationStatus] = useState(t1);
  const {
    authenticationData
  } = useAuth();
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      createInstance: () => {
        const newEntityManager = new AppEntityManager(new AppEntityManagerApiAdapter());
        testingHelper.entityManager = newEntityManager;
        return {
          entityManager: newEntityManager,
          init: async () => {
            await newEntityManager.init();
            newEntityManager.entitySynchronization.bindItemsToSynchronizeInfos(infos => {
              setSynchronizationStatus(status => ({
                ...status,
                itemsToSynchronizeInfos: infos.map(_temp)
              }));
            });
            newEntityManager.entitySynchronization.bindIsSynchronizing(isSynchronizing => {
              setSynchronizationStatus(status_0 => ({
                ...status_0,
                inProgress: isSynchronizing
              }));
            });
          },
          flush: () => newEntityManager.flush(),
          destroy: () => newEntityManager.destroy()
        };
      }
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    initializable,
    createNewInstance,
    removeInstance
  } = useInitializable(t2);
  let t3;
  let t4;
  if ($[4] !== createNewInstance || $[5] !== removeInstance) {
    t3 = () => {
      const beforeDisposable = StorageClearer.registerBeforeClearTask(() => removeInstance());
      const afterDisposable = StorageClearer.registerAfterClearTask(() => createNewInstance());
      return () => {
        beforeDisposable.dispose();
        afterDisposable.dispose();
      };
    };
    t4 = [createNewInstance, removeInstance];
    $[4] = createNewInstance;
    $[5] = removeInstance;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[8] !== authenticationData || $[9] !== initializable) {
    t5 = () => {
      if (initializable) {
        if (authenticationData) {
          initializable.entityManager.enableSynchronization();
        }
      }
      return () => initializable?.entityManager.disableSynchronization();
    };
    t6 = [authenticationData, initializable];
    $[8] = authenticationData;
    $[9] = initializable;
    $[10] = t5;
    $[11] = t6;
  } else {
    t5 = $[10];
    t6 = $[11];
  }
  useEffect(t5, t6);
  let t7;
  if ($[12] !== initializable) {
    t7 = initializable ? {
      entityManager: initializable.entityManager
    } : null;
    $[12] = initializable;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const contextValue = t7;
  if (!contextValue) {
    let t8;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <div>Intializing EntityManager..</div>;
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    return t8;
  }
  let t8;
  if ($[15] !== children || $[16] !== synchronizationStatus) {
    t8 = <SynchronizationStatusContext.Provider value={synchronizationStatus}>{children}</SynchronizationStatusContext.Provider>;
    $[15] = children;
    $[16] = synchronizationStatus;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== contextValue || $[19] !== t8) {
    t9 = <EntityManagerContext.Provider value={contextValue}>{t8}</EntityManagerContext.Provider>;
    $[18] = contextValue;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
});
function _temp(i) {
  return {
    id: i.entityId,
    entityName: i.entityName,
    failed: i.failed
  };
}